export const getDxAiPatientClinicMuiDialogContent = (palette: any) => ({
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: "0rem 1.5rem 1rem 1.5rem",
      },
    },
  },
});
